// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Loader } from "semantic-ui-react";

import { useAuth0 } from "../auth0";
const AutoLogin = () => {
	const { loginWithRedirect } = useAuth0();

	useEffect(() => {
		loginWithRedirect();
	}, []);

	return <Loader active />;
};

export default AutoLogin;
